import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-alert-erro-padrao',
    templateUrl: './alert-erro-padrao.component.html',
    styleUrls: ['./alert-erro-padrao.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertErroPadraoComponent {
    @Input() showAlertaErro: boolean;
    @Input() descricaoErro: any;
    @Output() alertErroPadraoFechou = new EventEmitter();

  constructor() { }

  fechaAlertaErro() {
    this.alertErroPadraoFechou.emit(true);
  }
}
